import { apiGwConfig, apiHost } from 'apiClients/api.config';
import { axiosApiGw } from 'apiClients/axiosSetup';
import { JawsApi } from 'apiClients/msc-api-gateway/proxy/jaws/client/jaws-api';
import { JawsDataMapper } from './Jaws.dataMapper';
import { JawsService } from './Jaws.service';

const apiClient = new JawsApi(apiGwConfig, apiHost, axiosApiGw);
const dataMapper = new JawsDataMapper(apiClient);
export const jawsService = new JawsService(dataMapper);
